export default "/images/vendor/flag-icon-css/flags/1x1/sy.svg?9d13beb594ee208a68642569e115b3ff";